{
	"title": "Manage declarations",
	"createDeclaration": "Create declaration"
}
